// Cost formatting helpers for the hierarchy canvas. Pure functions, no React — unit tested.

// compactCurrency renders a magnitude-rounded euro figure for node cards: finance scans the
// tree for scale, not cents, so we show "€48.9k" rather than "€48.917,34" (the exact value
// lives in the card's title attribute). One decimal in the k/M range, with a trailing ".0"
// dropped; whole euros below 1000. The sign is preserved for credits.
export function compactCurrency(value) {
  const n = Number(value) || 0;
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);

  if (abs < 1000) {
    return `${sign}€${Math.round(abs)}`;
  }
  const [divisor, suffix] =
    abs >= 1e9 ? [1e9, "B"] : abs >= 1e6 ? [1e6, "M"] : [1e3, "k"];
  // One decimal, then strip a trailing ".0" so "€49k" beats "€49.0k".
  const scaled = (abs / divisor).toFixed(1).replace(/\.0$/, "");
  return `${sign}€${scaled}${suffix}`;
}

// pctOfParent returns a node's share of its parent's subtree total, as an integer percent.
// Returns null when there is no meaningful share to show (no parent total / divide-by-zero),
// so the caller can omit the line rather than render "NaN%" or a misleading 0%.
export function pctOfParent(childSubtree, parentSubtree) {
  const parent = Number(parentSubtree);
  if (!parent) {
    return null;
  }
  return Math.round((Number(childSubtree) || 0) / parent * 100);
}
